module.exports = __webpack_public_path__ + "static/secure-8b32c857c280df071b42972ae61cdacc.png";